import styled from 'styled-components'
import { Col } from '@gympass/yoga'
import Container from '@components/Container'
import getBreakpoint from '@client/utils/breakpoints'

export const MainWrapper = styled.section`
  @media (min-width: ${getBreakpoint('md')}px) and (max-width: ${getBreakpoint(
      'lg'
    )}px) {
    ${Container} {
      max-width: 464px;
      margin: 0 auto;
    }
  }
`

export const FormColumn = styled(Col)`
  background-color: #ffffff;

  @media (min-width: ${getBreakpoint('xl')}px) {
    padding-left: 32px;
    padding-right: 32px;
  }
`

export const CardColumn = styled(Col)`
  background-color: #f5f5fa;
`
